import script from "./SettlementList.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementList.vue?vue&type=script&setup=true&lang=js"

import "./SettlementList.vue?vue&type=style&index=0&id=0e8c8a56&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8c8a56"]])

export default __exports__